import { Constants } from "@/web/constants";

export function chooseReturnUrl(returnUrl, defaultRoute) {
  const name = defaultRoute || Constants.ROUTE_MAIN_INTRODUCTION;
  return returnUrl ? returnUrl : { name };
}

export default chooseReturnUrl;
